<!-- Toast Notifications (top-right stack) -->
<div class="toast-container" *ngIf="toasts.length">
  <div
    *ngFor="let toast of toasts; trackBy: trackById"
    class="toast-item"
    [ngClass]="'toast-' + toast.type"
    role="alert"
    aria-live="polite"
    data-cy="notification-toast">

    <!-- Lottie animation for success -->
    <ng-container *ngIf="toast.type === 'success'">
      <ng-lottie
        [options]="getLottieOptions()"
        (animationCreated)="onAnimationCreated($event)"
        width="28px"
        height="28px"
        class="toast-lottie">
      </ng-lottie>
    </ng-container>

    <!-- SVG icon for non-success types -->
    <ng-container *ngIf="toast.type !== 'success'">
      <svg class="toast-icon" [ngClass]="getIconClass(toast.type)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="getIconSvg(toast.type)"/>
      </svg>
    </ng-container>

    <span class="toast-text">{{ toast.title }}</span>

    <!-- Progress bar -->
    <div class="toast-progress" *ngIf="toast.autoClose">
      <div class="toast-progress-bar" [ngClass]="'progress-' + toast.type"
           [style.animation-duration.ms]="toast.autoCloseMs"></div>
    </div>
  </div>
</div>

<!-- Modal Notifications (alert & confirm) -->
<ng-container *ngFor="let modal of modals; trackBy: trackById">
  <div
    class="modal-overlay"
    (click)="onBackdropClick($event, modal)"
    (keydown.escape)="modal.mode === 'confirm' ? onDeny(modal) : dismiss(modal.id)"
    role="dialog"
    aria-modal="true"
    data-cy="notification-modal">

    <div class="modal-panel" [ngClass]="'modal-' + modal.type">

      <!-- Icon -->
      <div class="modal-icon-wrapper" [ngClass]="'icon-bg-' + modal.type">
        <ng-container *ngIf="modal.type === 'success'">
          <ng-lottie
            [options]="getLottieOptions()"
            (animationCreated)="onAnimationCreated($event)"
            width="48px"
            height="48px">
          </ng-lottie>
        </ng-container>
        <ng-container *ngIf="modal.type !== 'success'">
          <svg class="modal-icon" [ngClass]="getIconClass(modal.type)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="getIconSvg(modal.type)"/>
          </svg>
        </ng-container>
      </div>

      <!-- Content -->
      <h3 class="modal-title">{{ modal.title }}</h3>
      <p class="modal-message" *ngIf="modal.message" [innerHTML]="modal.message"></p>

      <textarea
        *ngIf="modal.mode === 'confirm' && modal.requireInput"
        class="modal-input"
        rows="3"
        [placeholder]="modal.inputPlaceholder || ''"
        [(ngModel)]="modal.inputValue"
        data-cy="notification-input">
      </textarea>

      <!-- Buttons -->
      <div class="modal-actions">
        <ng-container *ngIf="modal.mode === 'alert'">
          <button class="btn-primary" (click)="dismiss(modal.id)" data-cy="notification-ok">
            Entendido
          </button>
        </ng-container>
        <ng-container *ngIf="modal.mode === 'confirm'">
          <button class="btn-secondary" (click)="onDeny(modal)" data-cy="notification-deny">
            {{ modal.denyText }}
          </button>
          <button class="btn-primary" [disabled]="!canConfirm(modal)" (click)="onConfirm(modal)" data-cy="notification-confirm">
            {{ modal.confirmText }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
